var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg21Plus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Twenty1Plus_2",
    "data-name": "Twenty1Plus 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 298.93 74.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .Twenty1Plus-1 {\n        font-family: RedSoxNationNormal, RedSoxNation;\n      }\n\n      .Twenty1Plus-1, .Twenty1Plus-2 {\n        fill: #e42a3b;\n        font-size: 38.17px;\n      }\n\n      .Twenty1Plus-3 {\n        fill: #f0e2cb;\n      }\n\n      .Twenty1Plus-2 {\n        font-family: MyriadPro-Regular, 'Myriad Pro';\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Twenty1Plus_1",
    "data-name": "Twenty1Plus 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Twenty1Plus-3",
    d: "M268.69,40.83c18.19-5.79,28.83-34.37,28.83-34.37-17.2,8.43-49.85,20.51-163.16-1.5C15.91-18.04,0,46.49,0,46.49c0,0,34.2-10.27,29.91-6.26-11.33,10.59-14.45,33.8-14.45,33.8,32.22-31.51,94.94-9.25,176.69-.8,81.75,8.44,106.78-30,106.78-30l-30.24-2.39Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "Twenty1Plus-1",
    transform: "translate(57.93 45.21) rotate(-2.22)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  })), /*#__PURE__*/React.createElement("text", {
    className: "Twenty1Plus-1",
    transform: "translate(78.24 44.54) rotate(3.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    className: "Twenty1Plus-1",
    transform: "translate(99.7 45.99) rotate(7.17)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    className: "Twenty1Plus-2",
    transform: "translate(115.31 47.89) rotate(10.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "+")), /*#__PURE__*/React.createElement("text", {
    className: "Twenty1Plus-1",
    transform: "translate(139.18 52.45) rotate(13.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    className: "Twenty1Plus-1",
    transform: "translate(156.64 56.67) rotate(15.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "n")), /*#__PURE__*/React.createElement("text", {
    className: "Twenty1Plus-1",
    transform: "translate(180.41 62.54) rotate(4.53)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "l")), /*#__PURE__*/React.createElement("text", {
    className: "Twenty1Plus-1",
    transform: "translate(199.38 63.97) rotate(-.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "y"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg21Plus);
export default __webpack_public_path__ + "static/media/21Plus.c99bc8c2f63a5c1818643a398539a2e7.svg";
export { ForwardRef as ReactComponent };